import { useEffect, useRef } from 'react';

import { useInViewPort } from '~/campaign/core/hooks/useIntersectionObserver';
import { useDataLayerContext } from '~/utilities/context/static/DataLayerContext';

export function useRecommendationsCategoriesTracking() {
  const categoriesRef = useRef<HTMLDivElement | null>(null);
  const { pushToDataLayer } = useDataLayerContext();
  const { inView, unobserve } = useInViewPort(categoriesRef);

  useEffect(() => {
    if (!inView) {
      return;
    }

    pushToDataLayer({
      event: 'recommended_category_links',
      type: 'view',
    });
    unobserve();
  }, [inView, unobserve, pushToDataLayer]);

  const handleCategoryClick = () => {
    pushToDataLayer({
      event: 'recommended_category_links',
      type: 'click',
    });
  };

  return { categoriesRef, handleCategoryClick };
}
